<template>
	<button
		type="button"
		class="cursor-pointer bg-transparent disabled:cursor-not-allowed disabled:opacity-50"
		:disabled="props.disabled"
	>
		<span
			class="rounded-full border-solid inline-flex justify-center items-center"
			:class="{
				[props.backgroundClass]: !props.checked,
				'!pointer-events-none': props.disabled,
				'border-2': props.borderWidth === 'default',
				'border': props.borderWidth === 'thin',
				'w-[2.2rem] h-[2.2rem] !border-[1.5px]': props.size === 'small',
				'w-7 h-7': props.size === 'medium',
				'w-10 h-10': props.size === 'large',
				'text-primary hover:bg-primary hover:text-white border-primary ': props.theme === 'default' && !props.checked,
				'text-white bg-primary border-primary ': props.theme === 'default' && props.checked,
				'text-error hover:bg-error hover:text-white border-error': props.theme === 'danger' && !props.checked,
				'text-white bg-error border-error': props.theme === 'danger' && props.checked,
				'text-secondary hover:bg-secondary hover:text-white border-secondary': props.theme === 'secondary' && !props.checked,
				'text-white bg-secondary border-secondary': props.theme === 'secondary' && props.checked,
			}"
		>
			<slot />
		</span>
	</button>
</template>

<script setup lang="ts">
export type ButtonCircleTheme = 'default' | 'danger' | 'secondary';

type Props = {
	checked?: boolean;
	size?: 'small' | 'medium' | 'large';
	backgroundClass?: `bg-${ string }`;
	theme?: ButtonCircleTheme;
	borderWidth?: 'default' | 'thin';
	disabled?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
	size: 'large',
	backgroundClass: 'bg-transparent',
	theme: 'default',
	borderWidth: 'default',
});
</script>
